import React from 'react';
import './EmptyBrandProfilesBox.css';

const EmptyBrandProfilesBox = () => (
  <div className="emptybrandprofilesbox__container" >
    No Brand Profiles !!
  </div>
);

export default EmptyBrandProfilesBox;